import { ApplicationStore } from 'Store/application';

type Route = ApplicationStore['routes'][0];

/** 
 * Defualt routes as generated by the application.
 */
export const DEFAULT_ROUTES: {[key: string]: Route} = {
  "home": {
    id: "home",
    path: "/"
  },
  "error": {
    id: "error",
    path: "/error"
  }
};